const LIFF_CHANNEL_ID = 1655801709;
const LIFF_ID = '1655801709-LWkyoX4y';

module.exports = {LIFF_CHANNEL_ID, LIFF_ID};